import { createEntityAdapter } from '@reduxjs/toolkit';

import { Order, OrderItem } from './types';

export const ordersAdapter = createEntityAdapter({
  selectId: (order: Order) => order.uuid,
});

export const orderItemsAdapter = createEntityAdapter({
  selectId: (item: OrderItem) => item.uuid,
});
